import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { FinanciacionPropiaListComponent } from './financiacion-propia-list.component';
import { FinanciacionPropiaService } from './financiacion-propia.service';

@Component({
    selector: 'convfact-financiacionpropiadelete',
    templateUrl: './financiacion-propia-dialog-delete.component.html',
    styleUrls: ['./financiacion-propia.component.css'],
    standalone: false
})
export class FinanciacionPropiaDialogDeleteComponent {

  public uid: string = this.data.uid;
  public response_message: string;
  public response_error: boolean;

  constructor(
    public dialogRef: MatDialogRef<FinanciacionPropiaListComponent>,
    public financiacionPropiaService: FinanciacionPropiaService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  public delete() {
    this.financiacionPropiaService.delete(this.uid)
      .then(res => {
        this.response_message = "La financiación se ha eliminado correctamente";
        this.response_error = false;
      }).catch(err => {
        this.response_message = "Ha ocurrido un error al eliminar la financiación";
        this.response_error = true;
      });
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
